if (!customElements.get('sticky-atc-button')) {
    customElements.define(
      'sticky-atc-button',
      class StickyAtcButton extends HTMLElement {
        constructor() {
          super();
   
          this.main_product_form = this.closest('.product').querySelector('.product-form form[action*="/cart/add"]') || document.querySelector('.product__page form[action*="/cart/add"]') || document.querySelector('.product form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add.js"]') || document.querySelector('form[action*="/cart/add"]');
          if (this.main_product_form === null) return console.error('Deployer Sticky Atc: No product form found');
   
          this.originalBtn = this.main_product_form.querySelector('button[name="add"]');
          this.originalPrice = document.querySelector('.product__info-container > .product__price .price');
          this.stickyAtcPriceElement = this.querySelector('.sticky-atc-button__price');
          this.stickyAtcButtonElement = this.querySelector('.sticky-atc-button__container');
          this.stickyButton = null;
          this.onVariantChangeUnsubscriber = undefined;
   
          this.handleStickyElements();
        }
   
        connectedCallback() {
          this.updateDisplay();
   
          window.addEventListener('scroll', () => {
            this.updateDisplay();
          });
   
          if (this.stickyButton) {
            this.stickyButton.addEventListener('click', () => {
              this.submitForm();
            });
          }
   
          // update when variant changes (works with Broadcast, Prestige, Dawn & co, Impulse)
          if (this.main_product_form.querySelector('input[name="id"]') !== null) {
            this.main_product_form.querySelector('input[name="id"]').addEventListener('change', () => {
              this.handleStickyElements();
            });
          } else {
            if (typeof subscribe === 'function') {
              this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
                this.handleStickyElements();
              });
            } else {
              document.addEventListener('variant:change', () => {
                this.handleStickyElements();
              });
            }
          }
        }
   
        updateDisplay() {
          if (this.originalBtn) {
            var rect = this.originalBtn.getBoundingClientRect();
            var footerRect = document.querySelector('footer').getBoundingClientRect();
            var windowHeight = window.innerHeight;
   
            // Vérifie si le bouton d'ajout principal est visible
            var isOriginalBtnVisible = rect.bottom > 0 && rect.top < windowHeight;
   
            // Vérifie si le footer est visible
            var isFooterVisible = footerRect.top < windowHeight && footerRect.bottom > 0;
   
            if (!isOriginalBtnVisible && !isFooterVisible) {
              this.classList.remove('sticky-atc-button--hidden');
            } else {
              this.classList.add('sticky-atc-button--hidden');
            }
          }
        }

        handleStickyElements() {
            this.cloneOriginalPrice();
            this.cloneOriginalButton();
            this.connectedCallback();
        }

        cloneOriginalPrice() {
          if (!this.stickyAtcPriceElement) return;
          const stickyAtcPrice = this.originalPrice.cloneNode(true);
          this.stickyAtcPriceElement.innerHTML = '';
          this.stickyAtcPriceElement.appendChild(stickyAtcPrice);
        }
   
        cloneOriginalButton() {
          if (!this.stickyAtcButtonElement) return;
          const stickyAtcButton = this.originalBtn.cloneNode(true);
          this.stickyAtcButtonElement.innerHTML = '';
          this.stickyAtcButtonElement.appendChild(stickyAtcButton);
          this.stickyButton = this.querySelector('button[type="submit"]');
        }
   
        submitForm() {
          this.stickyButton.setAttribute('aria-disabled', true);
          if (window.deployerAdapter.loadingClass != null && window.deployerAdapter.loadingSpinnerSelector != null) {
            this.stickyButton.classList.add(window.deployerAdapter.loadingClass);
            if (this.stickyButton.querySelector(window.deployerAdapter.loadingSpinnerSelector)) {
              this.stickyButton.querySelector(window.deployerAdapter.loadingSpinnerSelector).classList.remove('hidden');
            }
          }
          this.originalBtn.click();
          setTimeout(() => {
            if (window.deployerAdapter.loadingClass != null && window.deployerAdapter.loadingSpinnerSelector != null) {
              this.stickyButton.classList.remove(window.deployerAdapter.loadingClass);
              if (this.stickyButton.querySelector(window.deployerAdapter.loadingSpinnerSelector)) {
                this.stickyButton.querySelector(window.deployerAdapter.loadingSpinnerSelector).classList.add('hidden');
              }
            }
            this.stickyButton.removeAttribute('aria-disabled');
          }, 2000);
        }
      }
    );
  }